var map = {
	"./button-disabled-240.svg": 16669,
	"./button-error-240.svg": 84099,
	"./button-primary-160.svg": 98034,
	"./button-primary-240.svg": 8733,
	"./button-primary-320.svg": 66067
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54790;